import apifilaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apifilaweb.get('portariacargadescarga/produtor', { params: { ...where, ...params } }),
        apifilaweb.get('portariacargadescarga/produtor/count', { params: where }),
      ]);

      return { data, total };
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
